export const CHAT_COMMAND__GET_CONVERSATIONS = 1;
export const CHAT_COMMAND__GET_RECIPIENTS_ONLINE_STATUSES = 2;

export const CHAT_MSG_TYPE__CHAT_MSG = 1;
export const CHAT_MSG_TYPE__ERROR = 3;
export const CHAT_MSG_TYPE__IS_TYPING = 4;
export const CHAT_MSG_TYPE__RECIPIENT_STATUS_CHANGE = 5;
export const CHAT_MSG_TYPE__OFFLINE_WAIT = 6;
export const CHAT_MSG_TYPE__COMMAND = 7;
export const CHAT_MSG_TYPE__COMMAND_RESPONSE = 8;
export const CHAT_MSG_TYPE__OPEN_CONVERSATION = 9;
export const CHAT_MSG_TYPE__CLOSE_CONVERSATION = 10;
export const CHAT_MSG_TYPE__PING = 11;
export const CHAT_MSG_TYPE__PONG = 12;
export const CHAT_MSG_TYPE__APP_STATE_CHANGE = 13;

export const SOCKET_STATUS__OPEN = 1;
export const SOCKET_STATUS__CLOSED = 2;
export const SOCKET_STATUS__CONNECTING = 3;
export const SOCKET_STATUS__RETRYING = 4;
export const SOCKET_STATUS__FAILED = 5;
export const SOCKET_STATUS__CLOSING = 6;
export const SOCKET_STATUS__REFUSED = 7;

export const CHAT_STATUS_ONLINE = 1;
export const CHAT_STATUS_OFFLINE = 2;
